import { KontentDropdown } from "@components/global/Dropdown";
import { KontentLink } from "@components/global/FooterLink";
import { useStaticQuery, graphql } from "gatsby";

const useDesktopNavigationData = () => {
  const { kontentItemNavigation }: DesktopNavigationData =
    useStaticQuery(graphql`
      query DesktopNavigation {
        kontentItemNavigation(
          id: { eq: "42ce5091-ff5b-5d58-9f08-dc4088f8827c" }
        ) {
          elements {
            logo {
              value {
                width
                height
                description
                url
              }
            }
            main_links {
              value {
                system {
                  type
                }
                ... on kontent_item_dropdown {
                  elements {
                    title {
                      value
                    }
                    links {
                      value {
                        ... on kontent_item_link {
                          elements {
                            text {
                              value
                            }
                            open_in_new_window {
                              value {
                                codename
                              }
                            }
                            internal_path {
                              value
                            }
                            external_url {
                              value
                            }
                          }
                          system {
                            type
                          }
                        }
                        system {
                          type
                        }
                      }
                    }
                  }
                }
                ... on kontent_item_link {
                  elements {
                    text {
                      value
                    }
                    open_in_new_window {
                      value {
                        codename
                      }
                    }
                    internal_path {
                      value
                    }
                    external_url {
                      value
                    }
                  }
                }
              }
            }
            secondary_links {
              value {
                ... on kontent_item_link {
                  elements {
                    text {
                      value
                    }
                    open_in_new_window {
                      value {
                        codename
                      }
                    }
                    internal_path {
                      value
                    }
                    external_url {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    `);
  return kontentItemNavigation.elements;
};

export default useDesktopNavigationData;

// Type for an image
interface Image {
  width: number | null;
  height: number | null;
  description: string | null;
  url: string;
}

// Type for the main navigation links (can be either a link or a dropdown)
type MainLink = KontentLink | KontentDropdown;

// Type for the overall navigation data structure
export interface DesktopNavigationData {
  kontentItemNavigation: {
    elements: {
      logo: { value: Image[] };
      main_links: { value: MainLink[] };
      secondary_links: { value: KontentLink[] };
    };
  };
}
